import React from "react";
import { Tag } from "antd";

export function DocumentCheckTag({
  present,
}: {
  present: boolean | null | undefined;
}) {
  if (present == null) {
    return <Tag>—</Tag>;
  }
  return (
    <Tag color={present ? "green" : "default"}>{present ? "Yes" : "No"}</Tag>
  );
}
